import { useQueryClient } from "@tanstack/react-query";

/**
 * Anything edited below a campaign changes whether it has work waiting to go
 * live, so the campaign itself has to be refetched alongside whichever list was
 * actually mutated. Without this the publish prompt only appears on reload.
 */
export const useCampaignEdited = (campaignId: string) => {
	const queryClient = useQueryClient();

	return () => {
		void queryClient.invalidateQueries({ queryKey: ["campaign", campaignId] });
		void queryClient.invalidateQueries({ queryKey: ["campaigns"] });
	};
};
